import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ spacing }) => ({
  dateFilterPicker: {
    display: 'flex',
    alignItems: 'stretch',
    minHeight: spacing(4.5),
    boxSizing: 'border-box'
  },
  dateFilterAdornedEnd: {
    minHeight: spacing(7),
    paddingRight: spacing(1),
    '& >input': {
      padding: spacing(1, 0, 1, 1)
    }
  },
  keyboardAdornment: {
    padding: spacing(1)
  },
  dateFilterLabel: {}
}))
